import { type ChatHistory, type ChatSession, CoblinatorRequester, type FeedbackOption, type PromptRequest } from '@cobliteam/api-lib';
import { Environment } from '@cobliteam/react-environments';
import { useMutation, useQuery } from '@tanstack/react-query';

const env = Environment.getInstance().getEnvironment();

// Lazy instantiation to avoid circular dependency issues
const getCoblinatorRequester = () =>
  new CoblinatorRequester({
    host: env.apiHost,
  });

const QUERY_KEY = 'COBLINATOR';

const useRequestResponse = () =>
  useMutation<ChatHistory, unknown, { request: PromptRequest }>({
    mutationFn: (variables) => getCoblinatorRequester().requestResponse(variables.request),
  });

const useGetChatHistory = () =>
  useQuery<ChatSession[]>({
    queryKey: [QUERY_KEY, 'CHAT_HISTORY'],
    queryFn: () => getCoblinatorRequester().getChatHistory(),
  });

const useGiveChatFeedback = () =>
  useMutation<ChatHistory, unknown, { chatHistoryId: number; feedback: FeedbackOption }>({
    mutationFn: (variables) => getCoblinatorRequester().giveFeedback(variables.chatHistoryId, variables.feedback),
  });

export { useRequestResponse, useGetChatHistory, useGiveChatFeedback };
